export default {
  SET_LOADING(state, payload) {
    state.isLoading = payload
  },
  SET_MODAL_LOADING(state, payload) {
    state.isModalLoading = payload
  },
}
